import { SocketSubscribeConfig } from '../socketSubscribe';
import { ExportJobItemType } from 'packages/variation-export/AllExports/types';

export type InProgressJobData = {
    items: Pick<
        ExportJobItemType,
        'id' | 'name' | 'progresses' | 'type' | 'created' | 'updated' | 'jobVariations' | 'totalVariationsCount'
    >[];
    totalItems: number;
    totalVariationsCount: number;
};

type Options = SocketSubscribeConfig<InProgressJobData, {}>;

type Params = {
    creativeId: number;
    onMessage: Options['onMessage'];
};

type JobIdParams = {
    jobId: number;
    onMessage: Options['onMessage'];
};

export function subscribeExportJobsOptions({ creativeId, onMessage }: Params): Options {
    return {
        destination: `export-jobs/creative/${creativeId}/progress`,
        publishBody: {},
        onMessage,
    };
}

export function subscribeByJobIdExportJobsOptions({ jobId, onMessage }: JobIdParams): Options {
    return {
        destination: `export-jobs/${jobId}/progress`,
        publishBody: {},
        onMessage,
    };
}
